import type { MutationTree } from 'vuex'
import type { ScriptTemplatesState } from './state'
import type { ScriptTemplate } from '@/models/scriptTemplates'

export enum ScriptTemplatesMutationTypes {
  setScriptTemplates = 'setScriptTemplates',
}

export const mutations: MutationTree<ScriptTemplatesState> = {
  [ScriptTemplatesMutationTypes.setScriptTemplates](
    state,
    payload: ScriptTemplate[],
  ) {
    state.scriptTemplates = payload
  },
}
